/* eslint-disable no-unused-vars */
import React, {useEffect, useCallback} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'

import {KTCard, KTCardBody, KTCardHeader, ExpensesFast, Loading, HelpIcon} from '../../../../components'
import {PageTitle} from '../../../../core'

import {useSelector} from 'react-redux'
import {
  useMemoizedPageUrl,
  useMemoizedBreadcrumbs
} from '../../../../utils/performanceOptimizations'

const selectExpenseInvoiceData = (state) => ({
  isRedirect: state.expenseinvoice.isRedirect,
  loading: state.expenseinvoice.loading
})

function Create() {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const pageUrl = useMemoizedPageUrl(location)

  const {isRedirect, loading} = useSelector(selectExpenseInvoiceData)

  const breadcrumbs = useMemoizedBreadcrumbs(() => [
    {
      title: intl.formatMessage({id: 'BC.EXPENSES'}),
      path: '/expenses/expenses',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ], [intl])

  const handleRedirect = useCallback(() => {
    if (isRedirect && isRedirect.id) {
      navigate(`/${pageUrl[1]}/${pageUrl[2]}/${pageUrl[3]}/detail/${isRedirect.id}`)
    }
  }, [isRedirect, navigate, pageUrl])

  useEffect(() => {
    handleRedirect()
  }, [handleRedirect])

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>
        {intl.formatMessage({id: 'BC.EXPENSES.FAST.ADD'})}
      </PageTitle>
      <KTCard>
        <KTCardHeader title={intl.formatMessage({id: 'BC.EXPENSES.FAST.ADD'})}>
          <HelpIcon articleId='expense-entry' />
        </KTCardHeader>
        <KTCardBody>
          <ExpensesFast />
        </KTCardBody>
      </KTCard>

      {loading && <Loading />}
    </>
  )
}
export {Create}
